<app-title-pages-component
  [pageData]="pageData()">
</app-title-pages-component>

<div class="container">

  @if (!stepGeneratedTokens && !editingMode) {
    <div class="container-row">
      <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="12" fill="currentColor"/>
        <path d="M13.2158 17H11.9854V9.15918C11.6891 9.44173 11.2995 9.72428 10.8164 10.0068C10.3379 10.2894 9.90723 10.5013 9.52441 10.6426V9.45312C10.2126 9.12956 10.8141 8.73763 11.3291 8.27734C11.8441 7.81706 12.2087 7.37044 12.4229 6.9375H13.2158V17Z" fill="white"/>
      </svg>
      <span class="step-label">{{ campanasFormData()?.createCampaignTitle }}</span>
      <svg class="icon" width="20" height="1" viewBox="0 0 20 1" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="4.37114e-08" y1="0.5" x2="20" y2="0.500002" stroke="currentColor"/>
      </svg>
      @if (step2) {
        <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="currentColor"/>
          <path d="M15.0479 15.8174V17H8.42383C8.41471 16.7038 8.46257 16.4189 8.56738 16.1455C8.736 15.6943 9.00488 15.25 9.37402 14.8125C9.74772 14.375 10.2855 13.8691 10.9873 13.2949C12.0765 12.4017 12.8125 11.6953 13.1953 11.1758C13.5781 10.6517 13.7695 10.1572 13.7695 9.69238C13.7695 9.20475 13.5941 8.7946 13.2432 8.46191C12.8968 8.12467 12.4434 7.95605 11.8828 7.95605C11.2904 7.95605 10.8164 8.13379 10.4609 8.48926C10.1055 8.84473 9.92546 9.33691 9.9209 9.96582L8.65625 9.83594C8.74284 8.89258 9.06868 8.1748 9.63379 7.68262C10.1989 7.18587 10.9577 6.9375 11.9102 6.9375C12.8717 6.9375 13.6328 7.2041 14.1934 7.7373C14.7539 8.27051 15.0342 8.93132 15.0342 9.71973C15.0342 10.1208 14.9521 10.515 14.7881 10.9023C14.624 11.2897 14.3506 11.6976 13.9678 12.126C13.5895 12.5544 12.9583 13.1423 12.0742 13.8896C11.3359 14.5094 10.862 14.931 10.6523 15.1543C10.4427 15.373 10.2695 15.5941 10.1328 15.8174H15.0479Z" fill="white"/>
        </svg>
      } @else {
        <svg class="icon inactive" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11.5" stroke="currentColor"/>
          <path d="M15.0479 15.8174V17H8.42383C8.41471 16.7038 8.46257 16.4189 8.56738 16.1455C8.736 15.6943 9.00488 15.25 9.37402 14.8125C9.74772 14.375 10.2855 13.8691 10.9873 13.2949C12.0765 12.4017 12.8125 11.6953 13.1953 11.1758C13.5781 10.6517 13.7695 10.1572 13.7695 9.69238C13.7695 9.20475 13.5941 8.7946 13.2432 8.46191C12.8968 8.12467 12.4434 7.95605 11.8828 7.95605C11.2904 7.95605 10.8164 8.13379 10.4609 8.48926C10.1055 8.84473 9.92546 9.33691 9.9209 9.96582L8.65625 9.83594C8.74284 8.89258 9.06868 8.1748 9.63379 7.68262C10.1989 7.18587 10.9577 6.9375 11.9102 6.9375C12.8717 6.9375 13.6328 7.2041 14.1934 7.7373C14.7539 8.27051 15.0342 8.93132 15.0342 9.71973C15.0342 10.1208 14.9521 10.515 14.7881 10.9023C14.624 11.2897 14.3506 11.6976 13.9678 12.126C13.5895 12.5544 12.9583 13.1423 12.0742 13.8896C11.3359 14.5094 10.862 14.931 10.6523 15.1543C10.4427 15.373 10.2695 15.5941 10.1328 15.8174H15.0479Z" fill="currentColor"/>
        </svg>
      }
      <span [class]="step2 ? 'step-label' : 'step-label-2'">{{ campanasFormData()?.generateTokensButton }}</span>
    </div>
  }
  @if (step === 1) {
    <form [formGroup]="formCampaing" (ngSubmit)="onSubmit()">
      <!-- Nombre de la campaña -->
      <div class="form-row">
        <div class="input-container ">
          <input id="name" type="text" class="form-control" formControlName="name" required
                 [ngClass]="{ 'filled': formCampaing.get('name')?.value}"/>
          <label for="name">{{ campanasFormData()?.campaignNameLabel }}</label>

          @if (name?.invalid && (!name?.untouched || name?.dirty || submitted)) {
            <div class="alert alert-danger">
              @if (name!.hasError('required')) {
                <span>{{ campanasFormData()?.campaignNameError }}</span>
              }
            </div>
          }
        </div>

        <!-- Descripción -->
        <div class="input-container span-2">
          <input type="text" id="description" class="form-control" formControlName="description"
                 [ngClass]="{ 'filled': formCampaing.get('description')?.value}">
          <label for="description">{{ campanasFormData()?.campaignDescriptionLabel }}</label>
        </div>
      </div>

      <div class="form-row">
        <!-- URL de la encuesta-->
        <div class="input-container ">
          <input type="text" id="surveyUrl" class="form-control" formControlName="surveyUrl"
                 [ngClass]="{ 'filled': formCampaing.get('surveyUrl')?.value}">
          <label for="surveyUrl">{{ campanasFormData()?.surveyURLLabel }}</label>
        </div>

        <!-- Fecha de inicio de campaña -->
        <div class="input-container ">
          <input type="date" id="startDate" class="form-control" formControlName="startDate" required
                 [min]="minStartDate"
                 [ngClass]="{ 'filled': formCampaing.get('startDate')?.value || startDateFocused }"
                 (focus)="startDateFocused = true"
                 (blur)="startDateFocused = true"
          >
          <label for="startDate">{{ campanasFormData()?.campaignStartDateLabel }}</label>
          @if (startDate?.invalid && (!startDate?.untouched || startDate?.dirty || submitted)) {
            <div class="alert alert-danger">
              @if (startDate!.hasError('required')) {
                <span>{{ campanasFormData()?.startDateRequiredError }}</span>
              }
              @if (startDate!.hasError('futureDate')) {
                <span>{{ campanasFormData()?.startDateInvalidError }}</span>
              }
            </div>
          }
        </div>

        <!-- Fecha de fin de campaña -->
        <div class="input-container ">
          <input type="date" id="endDate" class="form-control" formControlName="endDate" required
                 [min]="minStartDate"
                 [ngClass]="{ 'filled': formCampaing.get('endDate')?.value || endDateFocused }"
                 (focus)="endDateFocused = true"
                 (blur)="endDateFocused = true">
          <label for="endDate">{{ campanasFormData()?.campaignEndDateLabel }}</label>

          @if (endDate?.invalid && (!endDate?.untouched || submitted)) {
            <div class="alert alert-danger">
              @if (endDate!.hasError('required')) {
                <span>{{ campanasFormData()?.endDateRequiredError }}</span>
              }
              @if (endDate!.hasError('invalidRange')) {
                <div class="alert alert-danger">
                  {{ campanasFormData()?.endDateBeforeStartError }}
                </div>
              }
            </div>
          }
        </div>
      </div>


      <div class="form-row">
        <!-- Total de empleados -->
        <div class="input-container ">
          <input type="number" id="totalEmployees" class="form-control" formControlName="totalEmployees" required
                 [ngClass]="{ 'filled': formCampaing.get('totalEmployees')?.value}">
          <label for="totalEmployees">{{ campanasFormData()?.totalEmployeesLabel }}</label>

          @if (totalEmployees?.invalid && (!totalEmployees?.untouched || totalEmployees?.dirty || submitted)) {
            <div class="alert alert-danger">
              @if (totalEmployees!.hasError('required')) {
                <span>{{ campanasFormData()?.totalEmployeesRequiredError }}</span>
              }
              @if (totalEmployees!.hasError('min')) {
                <span>{{ campanasFormData()?.totalEmployeesZeroError }}</span>
              }
            </div>
          }
        </div>

        <!-- Mínimo requerido-->
        <div class="input-container">
          <input type="number" id="minimumResponses" class="form-control" formControlName="minimumResponses"
                 [ngClass]="{ 'filled': (formCampaing.get('minimumResponses')?.value ?? '') !== '' }">
          <label for="minimumResponses">{{ campanasFormData()?.minRequiredLabel }}</label>
        </div>

        <!-- Tokens para generar -->
        <div class="input-container">
          <input type="number" id="tokensToGenerate" class="form-control" formControlName="tokensToGenerate" required
                 [ngClass]="{ 'filled': formCampaing.get('tokensToGenerate')?.value}">
          <label for="tokensToGenerate">{{ campanasFormData()?.tokensToGenerateLabel }}</label>
          @if (tokensToGenerate?.invalid && (!tokensToGenerate?.untouched || tokensToGenerate?.dirty || submitted)) {
            <div class="alert alert-danger">
              @if (tokensToGenerate!.hasError('required')) {
                <span>{{ campanasFormData()?.tokensToGenerateRequiredError }}</span>
              }
              @if (tokensToGenerate!.hasError('min')) {
                <span>{{ campanasFormData()?.tokensToGenerateZeroError }}</span>
              }
              @if (formCampaing.hasError('tokensExcedenEmpleados') && (tokensToGenerate?.dirty || submitted)) {
                <span>{{ campanasFormData()?.tokensToGenerateExceedError }}</span>
              }
            </div>
          }
          @if (formCampaing.hasError('tokensExcedenEmpleados') && (tokensToGenerate?.dirty || submitted)) {
            <div class="alert alert-danger">
              <span>{{ campanasFormData()?.tokensToGenerateExceedError }}</span>
            </div>
          }
          @if (formCampaing.hasError('tokensMenoresQueMinimo') && (tokensToGenerate?.dirty || submitted)) {
            <div class="alert alert-danger">
              <span>{{ campanasFormData()?.tokensToGenerateMinError }}</span>
            </div>
          }
        </div>
      </div>

      <div class="button-container">
        <button
          type="button"
          class="btn-cancel"
          (click)="goBack()"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn-guardar"
          [disabled]="isLocked || !formCampaing.dirty || formCampaing.invalid"
        >
          {{ modeEditCampaing ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
    </form>
  }

  @if (step === 2 || step === 3) {
    <form [formGroup]="formGenerateTokens">
      <!-- Nombre de la campaña -->
      <div class="form-row">
        <div class="input-container">
          <input id="nameCampain" type="text" class="form-control" formControlName="nameCampain"
                 [ngClass]="{ 'filled': formGenerateTokens.get('nameCampain')?.value}"/>
          <label for="nameCampain">{{ campanasFormData()?.assignedCampaignLabel }}</label>
        </div>

        <!-- Descripción -->
        <div class="input-container">
          <input type="number" id="numberOfTokens" class="form-control" formControlName="numberOfTokens"
                 [ngClass]="{ 'filled': formGenerateTokens.get('numberOfTokens')?.value}">
          <label for="numberOfTokens">Número de tokens</label>
          @if (formGenerateTokens.get('numberOfTokens')?.disabled) {
            <small class="limit-token-text">{{ campanasFormData()?.generateTokensMessageWarning }}</small>
          }
          @if (formGenerateTokens.get('numberOfTokens')?.invalid && (formGenerateTokens.get('numberOfTokens')?.dirty || formGenerateTokens.get('numberOfTokens')?.touched)) {
            <div class="alert alert-danger">
              @if (formGenerateTokens.get('numberOfTokens')!.hasError('required')) {
                <span>{{ campanasFormData()?.generateTokensRequiredError }}</span>
              }
              @if (formGenerateTokens.get('numberOfTokens')!.hasError('min')) {
                <span>{{ campanasFormData()?.generateTokensLessError }}</span>
              }
              @if (formGenerateTokens.get('numberOfTokens')!.hasError('max')) {
                <span>{{ campanasFormData()?.generateTokensExceedError }}</span>
              }
            </div>
          }
        </div>
        @if (!stepGeneratedTokens) {
          <div class="input-container">
            <button type="button" class="btn-generate"
                    (click)="generateTokens()">{{ campanasFormData()?.generateTokensGenerateButton }}
            </button>
          </div>
        }
        @if (stepGeneratedTokens) {
          <div class="input-container-1">
            <button type="button" class="btn-csv"
                    (click)="exportTokensToCSV()">{{ campanasFormData()?.tokensExportCSVButton }}
            </button>
            <button type="button" class="btn-excel"
                    (click)="exportTokensToExcel()">{{ campanasFormData()?.tokensExportExcelButton }}
            </button>
          </div>
        }
      </div>
    </form>
  }

  @if (stepGeneratedTokens) {
    @if (tokens.length > 0) {
      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th>Número</th>
            <th>Token</th>
            <th>Estado</th>
          </tr>
          </thead>
          <tbody>
            @for (tokenObj of tokens; track tokenObj.accessToken; let idx = $index) {
              <tr>
                <td>{{ idx + 1 }}</td>
                <td>{{ tokenObj.accessToken }}</td>
                <td [ngClass]="{ 'inactive': getStatus(tokenObj) === 'Inactivo' }">
                  <div class="status-button">{{ getStatus(tokenObj) }}</div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (tokens.length === 0 && showEmptyTokensModal) {
      <app-modal-add-tokens
        (confirm)="onConfirmGenerateTokens()"
        (cancel)="onCancel()">
      </app-modal-add-tokens>
    }
  }


  @if (isTokenView) {
    <a class="link-back" routerLink="/clientes/campañas">← {{ campanasFormData()?.returnToCampaignsList }}</a>
  }

  @if (showCompletionBanner) {
    <a class="link-back" routerLink="/clientes/campañas">← {{ campanasFormData()?.returnToListOfCampaigns }}</a>
  }

  <!-- Modal de carga -->
  @if (isLoading) {
    <app-modal-carga-component
      [title]="AppConstants.CAMPANAS_MODAL_CARGA_TITLE"
      [subTitle]="AppConstants.CAMPANAS_MODAL_CARGA_SUBTITLE">
    </app-modal-carga-component>
  }
</div>
